module.exports = __webpack_public_path__ + "static/clickmap1-7857c4387efe4599b104c930cc2e4dee.png";